import { createFileRoute, redirect } from "@tanstack/react-router";

import { authQueries } from "@/api/resources/auth/queries";
import LoginPage from "@/components/Login/LoginPage";

export const Route = createFileRoute("/login")({
  validateSearch: (search) =>
    search as {
      redirect?: string;
    },
  beforeLoad: async ({ context }) => {
    // redirect to index page (currentWorkspace determination) if claims exists
    const claims = await context.queryClient.fetchQuery(authQueries.getAuthClaims());
    if (claims) {
      throw redirect({
        to: "/",
      });
    }
  },
  component: LoginPage,
});
